import { OnboardingContainer, OnboardingHeaderContainer } from '@/components/escript/onboarding/Onboarding.styles';
import { UMEDS_MARKETING } from '@/routes/route-paths';
import UmedsLogo from '@montugroup/circuit-shared/components/common/UmedsLogo';
import { styled, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { OnboardingMenuDesktop } from '../OnboardingMenuDesktop/OnboardingMenuDesktop';
import { OnboardingMenuMobile } from '../OnboardingMenuMobile/OnboardingMenuMobile';

export const StyledUmedsLogo = styled(UmedsLogo)(({ theme }) => ({
  width: 'auto',
  [theme.breakpoints.up('md')]: {
    width: '148px',
  },
}));

export function OnboardingHeader() {
  const theme = useTheme();
  // NOTE: This is required to trigger the menu into mobile mode early so menu items aren't hidden under the logo
  const isMobileView = useMediaQuery(theme.breakpoints.down(1100));

  return (
    <OnboardingHeaderContainer>
      <OnboardingContainer>
        <Link to={UMEDS_MARKETING.HOME} aria-label="Go to uMeds Homepage">
          <StyledUmedsLogo fillColor={(theme) => theme.palette.primary.main} />
        </Link>
        {isMobileView ? <OnboardingMenuMobile /> : <OnboardingMenuDesktop />}
      </OnboardingContainer>
    </OnboardingHeaderContainer>
  );
}
